const statMethods = Object.freeze({
  mobile_push: [
    'mobile_push_sent',
    'mobile_push_opened',
    'mobile_push_open_rate'
  ],
  inapp: ['inapp_sent', 'inapp_delivered', 'inapp_opened', 'inapp_open_rate'],
  onsite: [
    'onsite_sent',
    'onsite_delivered',
    'onsite_opened',
    'onsite_open_rate'
  ],
  email: [
    'email_sent',
    'email_delivered',
    'email_opened',
    'email_open_rate',
    'email_clicked',
    'email_click_rate',
    'email_failed',
    'email_unsubscribed',
    'email_complained'
  ],
  web_push: [
    'web_push_sent',
    'web_push_opened',
    'web_push_delivered',
    'web_push_open_rate'
  ],
  sms: ['sms_sent', 'sms_delivered', 'sms_clicked', 'sms_click_rate'],
  inbox: ['inbox_sent', 'inbox_delivered', 'inbox_clicked', 'inbox_click_rate']
})

export { statMethods }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/VariantTestingMetrics.js